import { useContext } from 'react';
import c from 'classnames';
import styled from 'styled-components';
import { ContactInteractionInputManagerContext } from './contact-interaction-input-manager';

const Text = styled.span`
  color: ${({ theme }) => theme.colors.flint};
  font-family: ${({ theme }) => theme.font.regular};
  font-size: 11px;
  line-height: 14px;
  margin-right: 15px;
  position: relative;
  top: 3px;

  &.error {
    color: ${({ theme }) => theme.colors.secondaryCoral};
  }
`;

export const ContactInteractionInputAreaCharacterCounter = () => {
  const { messageValues, selectedChannelMessageConstraints } = useContext(
    ContactInteractionInputManagerContext,
  );
  const inputMessageLength = messageValues.message.length;
  const maxAllowedCharacters = selectedChannelMessageConstraints?.maxAllowedCharacters;

  return maxAllowedCharacters ? (
    <Text
      className={c({ error: inputMessageLength > maxAllowedCharacters })}
      data-lgg-id="contact-interaction-input-area-character-counter"
    >
      {inputMessageLength.toLocaleString()}/{maxAllowedCharacters.toLocaleString()}
    </Text>
  ) : null;
};
